import { useFactors } from "../state/FactorsContext";
import { describeResult } from "../lib/describe";
import HeroNumber from "./HeroNumber";
import ScenarioToggle from "./ScenarioToggle";

/**
 * The pinned bar. Whatever the reader scrolls to, the live result stays in
 * view — this is what keeps the number from disappearing. Compact on mobile
 * (number + a jump-to-controls link); on wider screens it also carries the
 * preset toggle.
 */
export default function Ticker() {
  const { result } = useFactors();
  const { plain } = describeResult(result.total);

  return (
    <div className="sticky top-0 z-30 border-b border-white/10 bg-void/80 backdrop-blur-md lg:hidden">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-2.5 sm:px-6">
        <div className="flex min-w-0 items-baseline gap-2.5">
          <span className="hidden shrink-0 text-[11px] uppercase tracking-[0.2em] text-cyan/80 sm:inline">
            Civilisations
          </span>
          <span className="text-lg sm:text-xl">
            <HeroNumber value={result.total} compact />
          </span>
          <span className="truncate text-xs text-white/55">{plain}</span>
        </div>

        <div className="hidden sm:block">
          <ScenarioToggle compact />
        </div>
      </div>
    </div>
  );
}
